export const environment = {
  production: false,
  apiUrl: 'https://inseelidev.svengit.com/api/i4u',
  name: 'dev',
  pdfHost: 'https://inseelidev.svengit.com',
  useMockPhase2: false,
};
